import { Box } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import React from 'react'

import CountdownCard from './CountdownCard'
import CountdownCardText from './CountdownCardText'

const extractDigits = (input: number) => input.toString().split('')

type CountdownCardHolderProps = {
  minDigits?: number
  unit: string
  value: number
}

const CountdownCardHolder = ({ unit, value, minDigits = 2 }: CountdownCardHolderProps) => {
  let digits = extractDigits(value)
  if (digits.length < minDigits) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const prependedZeroes: string[] = new Array(minDigits - digits.length).fill('0')
    digits = [...prependedZeroes, ...digits]
  }

  return (
    <Grid item>
      {/* eslint-disable-next-line sort-keys-fix/sort-keys-fix */}
      <Box mx={{ xs: 1, md: 1.5 }}>
        <Grid container wrap="nowrap">
          {digits.map((digit, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <CountdownCard key={index} value={digit} />
          ))}
        </Grid>
        <CountdownCardText text={unit} />
      </Box>
    </Grid>
  )
}

export default CountdownCardHolder
